import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { getProductById } from '../data/products';
import Footer from './Footer';
import { 
  RiCameraLine, 
  RiScissorsLine, 
  RiImageLine, 
  RiPaletteLine, 
  RiBrushLine, 
  RiEditLine,
  RiHeartLine,
  RiTimeLine,
  RiCalendarLine,
  RiSmartphoneLine,
  RiMagicLine,
  RiSparklingLine
} from 'react-icons/ri';

const ProductDetail = () => {
  const { productId } = useParams();
  const product = getProductById(productId);

  // 根据产品功能特色匹配图标
  const getFeatureIcon = (feature, productId) => {
    const iconClass = "w-6 h-6 text-primary";
    
    // 根据功能描述匹配图标
    if (feature.includes('拍照') || feature.includes('相机')) return <RiCameraLine className={iconClass} />;
    if (feature.includes('文案') || feature.includes('表达')) return <RiEditLine className={iconClass} />;
    if (feature.includes('识别') || feature.includes('抠图')) return <RiScissorsLine className={iconClass} />;
    if (feature.includes('批量') || feature.includes('处理')) return <RiImageLine className={iconClass} />;
    if (feature.includes('透明') || feature.includes('背景')) return <RiMagicLine className={iconClass} />;
    if (feature.includes('模板') || feature.includes('风格')) return <RiPaletteLine className={iconClass} />;
    if (feature.includes('美颜') || feature.includes('优化')) return <RiSparklingLine className={iconClass} />;
    if (feature.includes('转换') || feature.includes('算法')) return <RiMagicLine className={iconClass} />;
    if (feature.includes('滤镜') || feature.includes('调色')) return <RiBrushLine className={iconClass} />;
    if (feature.includes('修图') || feature.includes('去除')) return <RiEditLine className={iconClass} />;
    if (feature.includes('记录') || feature.includes('表情')) return <RiHeartLine className={iconClass} />;
    if (feature.includes('日历') || feature.includes('心情')) return <RiCalendarLine className={iconClass} />;
    if (feature.includes('时间') || feature.includes('瞬间')) return <RiTimeLine className={iconClass} />;
    
    // 默认图标
    return <RiSparklingLine className={iconClass} />;
  };

  if (!product) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">产品未找到</h1>
          <Link 
            to="/" 
            className="text-primary hover:text-primary/80 underline"
          >
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">

      {/* Banner区域 */}
      <section className="relative bg-gradient-to-br from-primary to-primary/80 py-20 overflow-hidden">
        {/* 背景纹理动画 */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 animate-pulse"></div>
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.1)_0%,transparent_50%)] animate-pulse" style={{animationDelay: '1s'}}></div>
        </div>
        
        <div className="container mx-auto px-4 md:px-6 text-center relative z-10">
          <div className="mb-8">
            <div className="w-32 h-32 mx-auto mb-8 rounded-[24px] overflow-hidden shadow-xl bg-white p-2">
              <img 
                src={product.logo} 
                alt={`${product.name} logo`} 
                className="w-full h-full object-cover rounded-[20px]"
              />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              {product.name}
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-2xl mx-auto">
              {product.description}
            </p>
          </div>
        </div>
      </section>

      {/* 产品介绍区域 */}
      <section className="py-20">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-dark mb-6">产品特色</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
                {product.features.map((feature, index) => (
                  <div key={index} className="bg-white rounded-xl p-6 shadow-lg">
                    <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg mb-4 mx-auto">
                      {getFeatureIcon(feature, productId)}
                    </div>
                    <h3 className="text-lg font-semibold text-dark mb-2">{feature}</h3>
                  </div>
                ))}
              </div>
            </div>

            {/* 产品截图 */}
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-dark mb-8">产品截图</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
                {product.images.map((image, index) => (
                  <div key={index} className="aspect-[9/16] overflow-hidden rounded-xl">
                    <img 
                      src={image} 
                      alt={`${product.name} 截图 ${index + 1}`} 
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ProductDetail;
